<div [ngStyle]="{ 'height.vh': height() }" class="google-map-container">
  @if (showStaticMap()) {
    <div
      (click)="openMapModal()"
      [style.background-image]="staticMapImgSrc()"
      [style.background-position]="'center center'"
      [style.background-size]="'cover'"
      class="static-map"
    >
      <div class="overlay">
        <div class="text">klicka för att öppna<br>en interaktiv karta</div>
      </div>
    </div>
  }
  <ng-template appMapHost></ng-template>
</div>
